export default class OrderGTMEvent {
  static getOderInfo(orderItems) {
    const { GiftMarkets, Markets } = orderItems;
    const combineArray = [...GiftMarkets, ...Markets];

    if (combineArray.length) {
      const itemArray = combineArray.map((product) => {
        return {
          item_name: product.Name,
          affiliation: product.ColorName,
          item_brand: product.Size,
          item_list_name: '購物車清單',
          price: product.SellPrice,
          quantity: product.Count,
        };
      });

      return itemArray;
    }

    return [];
  }
}
